module.exports = __webpack_public_path__ + "img/et1.0a2f0c1a.png";